module.exports = __webpack_public_path__ + "static/media/arrivalsIcon.16a19f52.svg";